/**
 * Top shell: link to the shared export hub.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';

const EXPORT_HUB_PATH = '/report?tab=export';

export type ShellIncidentExportNavProps = {
  open: boolean;
  onToggle: () => void;
  hasMedError: boolean;
  hasFall: boolean;
  /** `desktop` = dropdown in header; `mobile` = stacked actions in drawer */
  variant: 'desktop' | 'mobile';
};

export const ShellIncidentExportNav: React.FC<ShellIncidentExportNavProps> = ({
  open,
  onToggle,
  hasMedError,
  hasFall,
  variant,
}) => {
  if (!hasMedError && !hasFall) return null;

  if (variant === 'mobile') {
    return (
      <div className="border-t border-slate-100 px-3 py-3">
        <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">ส่งออกข้อมูล</div>
        <Link
          to={EXPORT_HUB_PATH}
          onClick={onToggle}
          className="inline-flex w-full items-center justify-between rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm font-medium text-slate-800 hover:bg-slate-50"
        >
          <span>ไปหน้า “ส่งออก”</span>
          <Download className="h-4 w-4 opacity-80" aria-hidden />
        </Link>
      </div>
    );
  }

  return (
    <Link
      to={EXPORT_HUB_PATH}
      onClick={() => {
        if (open) onToggle();
      }}
      className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-800"
      aria-label="ไปหน้า ส่งออก"
    >
      <Download className="h-4 w-4 shrink-0 opacity-80" strokeWidth={2.25} aria-hidden />
      <span>ส่งออก</span>
    </Link>
  );
};
